import axios from "axios";
import { appConstants } from "./appConstants";
import { clearCachedRequest, getCachedRequest } from "./requestCache";

const generations = new Map();
const cacheKey = (businessUserID) =>
  `quotation-number:${businessUserID}:${generations.get(businessUserID) || 0}`;

export function getQuotationNumberPreview(businessUserID) {
  if (!businessUserID) return Promise.reject(new Error("Business User ID is required."));
  const key = cacheKey(businessUserID);
  return getCachedRequest(key, async () => {
    const { data } = await axios.post(
      `${appConstants.baseURL}quotation/getQuotationNumber`,
      { businessUserID },
      { headers: { Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}` }, timeout: 15000 }
    );
    if (!data?.Result_Status || !data.Result_Output?.quotationNumber)
      throw new Error("Could not generate the quote number. Please try again.");
    return data.Result_Output.quotationNumber;
  }, 15000).then((number) => {
    if (key !== cacheKey(businessUserID)) clearCachedRequest(key);
    return number;
  });
}

export function clearQuotationNumberPreview(businessUserID) {
  clearCachedRequest(cacheKey(businessUserID));
  generations.set(businessUserID, (generations.get(businessUserID) || 0) + 1);
}
